function onAgeCheck(id) {
    try {
        var check = document.getElementById("age-check");
        var button = document.getElementById(id);
        button.disabled = !check.checked;
    } catch (e) {
        console.error(e);
    }
}